import axios from 'axios'

export const mapGenerator = axios.create({
    baseURL: '/bet-mapgenerator'
});

export const orion = axios.create({
    baseURL:'https://api.bettair.city/context/v2/',
    timeout:4000
});

export const organizations = axios.create({
    // baseURL:'/api_organization',
    baseURL:'https://api.bettair.city',
    timeout:4000
});

export const historical = axios.create({
    baseURL:'https://api.bettair.city/historical/v2/',
    timeout:4000
});



// WEBPACK FOOTER //
// ./src/config/axios.js